import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAppAnalytics } from '../../redux/AppSlice'
import { ReviewData } from '../../Componets'
import { intersection_threshold, OrderIcon, ProductIcon, ShopIcon, UsersIcon } from '../../base'

function AppAnalytics() {
  const { total_user, total_product, total_order, total_shop, avg_rating, total_review, get_app_analytics } = useSelector((state) => state.appSlice)
  const dispatch = useDispatch()
  const componentRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // Check if the child component is in the viewport
        if (entries[0].isIntersecting && get_app_analytics === false) {
          // Trigger the API call or any function passed as prop
          dispatch(getAppAnalytics())
        }
      },
      {
        root: null, // default to the viewport
        threshold: intersection_threshold, // 50% of the component must be visible
      }
    );

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      if (componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, [get_app_analytics])


  return (
    <div className='appAnalytics' ref={componentRef}>
      <div className='records'>
          <div className='container d-flex gap-5'  style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', flexWrap : 'wrap' }}>
            <div className='singleRecord'>
              <UsersIcon style={{width : '35px'}} />
              <div className='h4 '>{total_user} + </div>
              <div className='h6 scolor'>Total Users</div>
            </div>
            <div className='singleRecord'>
              <ShopIcon style={{width : '35px'}}/>
              <div className='h4 '>{total_shop} + </div>
              <div className='h6 scolor'>Total Shops</div>
            </div>
            <div className='singleRecord'>
              <OrderIcon style={{width : '23px'}} />
              <div className='h4 '>{total_order} + </div>
              <div className='h6 scolor'>Order Completed</div>
            </div>
            <div className='singleRecord'>
              <ProductIcon style={{width : '30px'}} />
              <div className='h4 '>{total_product} + </div>
              <div className='h6 scolor'>Total Products</div>
            </div>
          </div>
      </div>

      <hr className='mb-5' />
      <ReviewData id={-1} page='app' total_review={total_review} avg_rating={avg_rating} />
    </div>
  )
}

export default AppAnalytics